import { Button, Grid, Skeleton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import { rem } from "assets/js/common";
import { loadAlert, loadFavAlert } from "redux/reducers/top";
import { Cookies } from "react-cookie";
import axios from "axios";
import { loadMainAction } from "redux/reducers/home";
import { DrawerProduct } from "components/product-of-week/drawer-product";
import { Link, useHistory } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";

const useStyles = makeStyles((theme) => ({
  product: {
    "&.productOfWeek": {
      borderTop: "45px solid #F6F6F6",
      "& .best-items": {
        padding: `${rem(70)} 0 ${rem(40)}`,
        "& .best-items-header": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: `0 ${rem(30)} ${rem(25)}`,
          "& h3": {
            fontSize: rem(20),
            lineHeight: rem(26),
          },
          "& .btn-rounded": {
            height: rem(28),
            padding: `0 ${rem(14)}`,
          },
        },
      },
      "& .bestItems": {
        position: "relative",
        marginLeft: 0,
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        "& .mySwiper": {
          paddingBottom: 0,
          "& .swiper-wrapper > .swiper-slide": {
            // width: rem(150),
            width: "40%",
            "&:first-child": {
              marginLeft: rem(15),
            },
          },
        },
        "& .item": {
          width: "100%",
          paddingBottom: 0,
          paddingTop: rem(4),
          // marginLeft: rem(30),
          "& .item-img": {
            width: "100%",
            background: theme.palette.background.default,
            "& .MuiSkeleton-root": {
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            },
            "& .badge .txt": {
              width: rem(34),
              height: rem(34),
              fontSize: rem(12),
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              "-webkit-line-clamp": 2,
              "-webkit-box-orient": "vertical",
              wordWrap: "break-word",
            },
          },
        },
      },
      "& .btn-total": {
        "& button": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          "&:before": {
            content: "''",
            width: rem(20),
            height: rem(20),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/arrow-circle.svg)`,
            backgroundSize: `${rem(20)} ${rem(20)}`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          },
          "& span": {
            fontSize: rem(14),
            color: theme.palette.primary.main,
            fontWeight: 700,
            lineHeight: rem(22),
            marginTop: rem(7),
          },
        },
      },
    },
  },
}));
const cookies = new Cookies();
export default function Product(props) {
  const { drawerHigh, handleDrawerHighOpen, handleDrawerHighClose } = props;
  const classes = useStyles();
  const { data, loading } = useSelector((state) => state.home);
  const [productList, setProductList] = useState([]);
  const dispatch = useDispatch();
  const [token, setToken] = useState("");
  const [flyer, setFlyer] = useState([]);
  const history = useHistory();

  let favInfo = cookies.get("favInfo");
  const [visibleTp, setVisibleTp] = useState(
    favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1
  );

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  useEffect(() => {
    if (data.productList) setProductList(data.productList.list);
  }, [data]);

  const handleFav = (item, i) => {
    if (token) {
      axios
        .post("/api/eh/product/favorite/fav", {
          seq: item.seq,
        })
        .then((res) => {
          let data = res.data.data;
          item = {
            ...item,
            favCnt: data == "Y" ? item.favCnt + 1 : item.favCnt - 1,
            favYn: data,
          };
          const ll = [...productList];
          ll.splice(i, 1, item);
          setProductList(ll);
          // dispatch(loadMainAction({ schTp: visibleTp, schStore: storeCode }));
        });
    } else {
      dispatch(loadAlert(true));
    }
  };

  const loadFlyer = () => {
    let localToken = cookies.get("X-AUTH-TOKEN");
    let localFavInfo = cookies.get("favInfo");

    let stCode = localFavInfo
      ? localFavInfo.visibleTp == "1"
        ? localFavInfo.favMt
        : localFavInfo.favMk
      : "";

    axios
      .get(
        `/api/sm/store/get-leaflet/${
          localToken ? (stCode ? stCode : "2701") : "2701"
        }`
      )
      .then((res) => {
        setFlyer(res.data.data);
      })
      .catch((error) => {
        setFlyer([]);
      });
  };

  useEffect(() => {
    setToken(cookies.get("X-AUTH-TOKEN"));
    loadFlyer();
  }, [favInfo && favInfo.visibleTp]);

  if (loading)
    return (
      <div className={"productOfWeek " + classes.product}>
        <div className="best-items">
          <div className="best-items-header">
            <h3 className="weight800">
              <Skeleton variant="rectangular" width={100} height={26} />
            </h3>
          </div>
          <div className="bestItems">
            <Swiper spaceBetween={15} slidesPerView={2.2} className="mySwiper">
              {[...Array(4)].map((item, i) => (
                <SwiperSlide key={`pro-skel-${i}`}>
                  <div className="item">
                    <div className="item-img" style={{ background: "none" }}>
                      <Skeleton
                        variant="rectangular"
                        width={140}
                        height={140}
                        style={{ borderRadius: rem(10) }}
                      />
                    </div>
                    <div className="tit">
                      <Skeleton variant="rectangular" width={120} height={15} />
                    </div>

                    <div className="sub-tit">
                      <Skeleton variant="rectangular" width={100} height={12} />
                    </div>

                    <div className="price">
                      <Skeleton variant="rectangular" width={80} height={24} />
                    </div>

                    <div className="cnt">
                      <Skeleton variant="rectangular" width={100} height={12} />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );

  return (
    <>
      {productList.length > 0 && (
        <div className={"productOfWeek " + classes.product}>
          <div className="best-items">
            <div className="best-items-header">
              <h3 className="weight800">행사상품</h3>
              <Button
                className="btn-rounded"
                color="primary"
                variant="contained"
                size="small"
                onClick={() => {
                  if (token && !storeCode) dispatch(loadFavAlert(true));
                  else handleDrawerHighOpen();
                }}
              >
                종이전단 보기
              </Button>
            </div>
            <div className="bestItems">
              {productList.length > 0 && (
                <Swiper
                  spaceBetween={15}
                  slidesPerView={"auto"}
                  // slidesOffsetAfter={130}
                  className="mySwiper"
                >
                  {productList.map((item, i) => (
                    <SwiperSlide key={`prop-${i}`}>
                      <div
                        className="item"
                        onClick={() => {
                          history.push({
                            pathname: `/product-of-week/detail/${item.seq}`,
                            props: {
                              seq: item.seq,
                            },
                          });
                        }}
                      >
                        <div className="item-img">
                          <div className="img-wrap">
                            <img src={item.prodImgUrl} />
                          </div>
                          {item.dcMak && (
                            <div className="badge">
                              <div className="txt">{item.dcMak}</div>
                            </div>
                          )}
                        </div>
                        <div className="tit">{item.ttl}</div>
                        {item.prchTrms && (
                          <div className="sub-tit">{item.prchTrms}</div>
                        )}
                        <div className="price">
                          {item.prc.toLocaleString()}
                          <span>원</span>
                        </div>
                        {item.dcTp && (
                          <>
                            <div className="grey-box">{item.dcTp}</div>
                          </>
                        )}
                        {item.prmtCont && (
                          <div className="red-box">{item.prmtCont}</div>
                        )}
                        {item.qty && (
                          <div className="cnt">
                            한정수량 {item.qty.toLocaleString()}개
                          </div>
                        )}

                        <div className="func-btn">
                          <Button
                            className="fav"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleFav(item, i);
                            }}
                          >
                            <img
                              src={`${
                                process.env.PUBLIC_URL
                              }/images/icon/favorite${
                                item.favYn == "Y" ? "" : "-off-d"
                              }.svg`}
                              alt="찜"
                            />
                            <span
                              style={{
                                color:
                                  item.favYn == "Y" ? "#F1270B" : "#8e8e8e",
                              }}
                            >
                              {item.favCnt}
                            </span>
                          </Button>
                          {item.prodTp == "1" && (
                            <Button
                              className="fav"
                              // onClick={() => {
                              //   handleFav(item, i);
                              // }}
                            >
                              <img
                                src={`${
                                  process.env.PUBLIC_URL
                                }/images/icon/review.svg`}
                                alt="댓글"
                              />
                              <span
                                style={{
                                  color: "#8e8e8e",
                                }}
                              >
                                {item.rvCnt}
                              </span>
                            </Button>
                          )}
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}

                  <SwiperSlide
                    className="btn-total"
                    style={{ width: "auto", padding: "15% 40px 0 20px" }}
                  >
                    <Button
                      onClick={() => {
                        history.push("/product-of-week");
                      }}
                    >
                      <span>전체보기</span>
                    </Button>
                  </SwiperSlide>
                </Swiper>
              )}
            </div>
          </div>
          <DrawerProduct
            flyer={flyer}
            drawerHigh={drawerHigh}
            handleDrawerHighClose={handleDrawerHighClose}
          />
        </div>
      )}
    </>
  );
}
